import AnimatedPage from './AnimatedPage';
import ContentSimple from '../components/ContentSimple';
import IconPDF from '../components/assets/IconPDF';

import Button from '../components/Button';
import { ButtonTypes } from '../setup/enum-buttontypes';

function Voorwaarden() {
	return (
		<AnimatedPage title={'Disclaimer website'}>
			<ContentSimple
				className="contentsimple--white"
				button={<Button newTab icon={<IconPDF />} className="button--main" link={`${process.env.PUBLIC_URL}/disclaimerinfoorthomoleculairvoedingsadviesjolandadierenarts.pdf`} text={'Download'} type={ButtonTypes.ButtonIcon} />}
				content={
					<>
						<p>
							<br />
							<br />
							<br />
							<br />
						</p>
						<h2>Disclaimer en informatie orthomoleculair voedingsadvies</h2>
						<p>U kunt de Disclaimer en informatie orthomoleculair voedingsadvies als PDF downloaden.</p>
					</>
				}
			/>
		</AnimatedPage>
	);
}

export default Voorwaarden;
